import { useSetAtom } from 'jotai';

import { useActivateWorkspaceCode } from '~teacher/hook/workspaces/code/useActivateWorkspaceCode';

import { WorkspaceRole } from '../../../../../api/workspaces/getWorkspaceMembers';
import { workspaceInviteDialogAtom } from '../atoms/atoms';

interface UseOnToggleEnabledParams {
  workspaceId: string;
  workspaceRole: WorkspaceRole;
  canTurnOff: boolean;
}

export function useOnToggleEnabled({
  workspaceId,
  workspaceRole,
  canTurnOff,
}: UseOnToggleEnabledParams) {
  const dispatch = useSetAtom(workspaceInviteDialogAtom);
  const activateCodeMutation = useActivateWorkspaceCode();

  return (shouldEnable: boolean) => {
    if (shouldEnable) {
      activateCodeMutation.mutate({ workspaceId, workspaceRole });
    } else {
      // should disable
      if (!canTurnOff) return;

      dispatch({
        type: 'Open',
        payload: {
          memberRole: workspaceRole,
          view: 'ActionOverlayDisableLink',
        },
      });
    }
  };
}
